import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

// Keeps long admin lists short on mobile: shows the first `collapsedCount` items with a
// "Show all (N)" toggle. The wrapper keeps whatever layout classes you pass (grid, divide-y…).
export const CollapsibleList = ({ children, collapsedCount = 5, className = "", testid = "collapsible" }) => {
  const [open, setOpen] = useState(false);
  const items = React.Children.toArray(children).filter(Boolean);
  const hidden = items.length - collapsedCount;
  const shown = open ? items : items.slice(0, collapsedCount);

  return (
    <>
      <div className={className} data-testid={testid}>{shown}</div>
      {hidden > 0 && (
        <button type="button" onClick={() => setOpen((o) => !o)} data-testid={`${testid}-toggle`}
          className="mt-3 w-full inline-flex items-center justify-center gap-1.5 rounded-xl border border-border hover:border-[#16a34a] text-xs font-bold text-foreground px-4 py-2.5 transition-colors">
          {open ? <><ChevronUp size={14} /> Show less</> : <><ChevronDown size={14} /> Show all {items.length}</>}
        </button>
      )}
    </>
  );
};

export default CollapsibleList;
